const getPictureUrl = (pictures, width, height) => {
  const { url } = (pictures && pictures.length && pictures[0]) || "";
  let newUrl = null;
  if (url) {
    let replacedWidth = (url && url.replace("[WIDTH]", width)) || "";
    newUrl = (replacedWidth && replacedWidth.replace("[HEIGHT]", height)) || "";
  }
  return newUrl;
};

export default getPictureUrl;
